import { jwtDecode } from 'jwt-decode';

export const isAdminFromToken = (idToken) => {
  if (!idToken) return false;
  try {
    const decoded = jwtDecode(idToken);
    const roles = decoded.roles || decoded.appRoles || decoded.roles_claim || [];
    if (Array.isArray(roles)) {
      return roles.includes('Admin') || roles.includes('admin');
    }
  } catch (e) {

  }
  return false;
};

export default isAdminFromToken;